import { render } from "./index.vue?vue&type=template&id=2feab05d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2feab05d&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2feab05d"],['__file',"src/views/room/roomCount/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2feab05d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2feab05d', __exports__)) {
    console.log('reload')
    api.reload('2feab05d', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=2feab05d&scoped=true", () => {
    console.log('re-render')
    api.rerender('2feab05d', render)
  })

}


export default __exports__